import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import defined from 'defined';
import { SELECT_PROP_TYPES, SELECT_DEFAULT_PROPS, OPTION_PROP_TYPES, OPTGROUP_PROP_TYPES } from '../prop-types';
import DropdownTrigger from '../dropdown-trigger';

var Option = function Option(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      value = _ref.value;
  return React.createElement("option", {
    value: defined(value, label),
    disabled: disabled
  }, label);
};

Option.displayName = 'Option';
Option.propTypes = OPTION_PROP_TYPES;

var OptGroup = function OptGroup(_ref2) {
  var title = _ref2.title,
      options = _ref2.options;
  return React.createElement("optgroup", {
    label: title,
    key: title
  }, options.map(function (o) {
    return React.createElement(Option, _extends({}, o, {
      key: defined(o.value, o.label)
    }));
  }));
};

OptGroup.displayName = 'OptGroup';
OptGroup.propTypes = OPTGROUP_PROP_TYPES;
/**
 * Renders a native select component.  Automatically used by
 * `Select` if *either* of the following conditions are true:
 *
 * 1. `popover` and `multiple` are false
 * 2. User device is coarsely-pointed (e.g. touch device).
 */

var NativeSelect = function NativeSelect(_ref3) {
  var options = _ref3.options,
      unselected = _ref3.unselected,
      otherProps = _objectWithoutProperties(_ref3, ["options", "unselected"]);

  return React.createElement(DropdownTrigger, _extends({}, otherProps, {
    mode: "select"
  }), unselected !== null && React.createElement("option", {
    label: unselected,
    value: "",
    disabled: true,
    "aria-label": ""
  }), options.map(function (option) {
    return option.options ? React.createElement(OptGroup, _extends({}, option, {
      key: option.title
    })) : React.createElement(Option, _extends({}, option, {
      key: defined(option.value, option.label)
    }));
  }));
};

NativeSelect.displayName = 'NativeSelect';
NativeSelect.propTypes = SELECT_PROP_TYPES;
NativeSelect.defaultProps = SELECT_DEFAULT_PROPS;
export default NativeSelect;